import { render, staticRenderFns } from "./addBankAccount.vue?vue&type=template&id=4d264453&scoped=true"
import script from "./addBankAccount.vue?vue&type=script&lang=js"
export * from "./addBankAccount.vue?vue&type=script&lang=js"
import style0 from "./addBankAccount.vue?vue&type=style&index=0&id=4d264453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d264453",
  null
  
)

export default component.exports